import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../Globals/styles';
import WeekdayWorkplaceDrop from './weekdayWorkplaceDrop';
import Booking from './booking';
import StickyNote from './stickyNote';

class WeekDay extends Component {
  isWorkplaceDropped = (workplaceId) => {
    const { workplaces } = this.props;
    let isWorkplaceDropped = false;
    workplaces.forEach((workplace) => {
      if (workplace.id===workplaceId) isWorkplaceDropped = true
    })
    return isWorkplaceDropped;
  };
	render() {
    const { onWorkplaceDrop, workplaces, openEditBookingModal, openEditStickyNoteModal, onStickynoteDrop, goToDagrapport, pendingBookings,
    isCompressed, maxHeight, stickynotes} = this.props;
    let workplaceNodes = workplaces.map((workplace, index) => {
      return (
        <Booking
          key={workplace.id}
          workplace={workplace}
          openEditBookingModal={() => openEditBookingModal(index)}
          goToDagrapport={() => goToDagrapport(workplace.id, this.props.index, workplace.hours)}
          isCompressed={isCompressed}
        />
      )
    });

    let stickyNoteNodes = stickynotes.map((stickynote, index) => {
      return(
        <StickyNote
          index={index}
          key={stickynote.id}
          id={stickynote.id}
          color={stickynote.color}
          text={stickynote.text}
          isCompressed={isCompressed}
          openEditStickyNoteModal={()=> openEditStickyNoteModal(index)}
        />
      )
    });



    let pending = pendingBookings.map((pendingBooking) => {
      return (
        <div key={pendingBooking.workplaceId} style={[styles.workplace]}>
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
        )
    });


    let height = isCompressed ? (maxHeight * 35)-10 + "px" : (maxHeight * 160)-10 + "px";
    if(maxHeight===0)
      height = '25px';
		return (
      <div style={styles.outerContainer}>
        <div style={[styles.container, {height: height}]}>
          <WeekdayWorkplaceDrop
            onWorkplaceDrop={onWorkplaceDrop}
            isWorkplaceDropped={this.isWorkplaceDropped}
            isCompressed={isCompressed}
            onStickynoteDrop={onStickynoteDrop}
          />
          {stickyNoteNodes}
          {workplaceNodes}
          {pending}
        </div>
      </div>
		);
	}
}

var styles = {
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: semanticColors.default,
    position: 'relative',
    borderRadius: '2px'
  },
  workplace: {
    backgroundColor: greyScaleColors.greyLighter,
    marginBottom: '10px',
    padding: '5px',
    minHeight: '140px',
    fontSize: '12px',
    borderRadius: '2px',
    textAlign: 'center'
  },
  borderBottom : {
    borderBottom: '1px solid ' + semanticColors.mainBackground
  },
  paddingBottom: {
    paddingBottom: '5px'
  },
  label : {
    display: 'inline-block',
    backgroundColor: semanticColors.mainBackground,
    borderRadius: '2px',
    textAlign: 'center',
    color: '#fff',
    height: '20px',
    width: '30px',
    marginRight: '5px',
    marginTop: '2px'
  },
  labelsBox : {
    padding: '2px'
  }
}

WeekDay.propTypes = {
    onWorkplaceDrop: PropTypes.func.isRequired,
    workplaces: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      client: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        contact: PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired
        }).isRequired
      }).isRequired,
      employees: PropTypes.object,
      project: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired
      }).isRequired,
      startTime: PropTypes.number.isRequired,
      endTime: PropTypes.number.isRequired,
      hours: PropTypes.number
    })),
    index: PropTypes.number.isRequired,
    openEditBookingModal: PropTypes.func.isRequired,
    openEditStickyNoteModal: PropTypes.func.isRequired,
    goToDagrapport: PropTypes.func.isRequired,
    pendingBookings: PropTypes.arrayOf(PropTypes.object),
    isCompressed: PropTypes.bool.isRequired,
    onStickynoteDrop: PropTypes.func.isRequired
  };

export default Radium(WeekDay)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/weekday.jsx